import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { ApiService } from 'src/app/core/api.service';
import { User } from 'src/app/core/models/user';
import { SystemService } from 'src/app/core/system.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  user: User;

  // carousel for keyboards
  keyboardChanged$ = new Subject<string>();

  constructor(
    private router: Router,
    private apiService: ApiService,
    public systemService: SystemService,
    private authService: AuthService) { }

  ngOnInit() {

    this.authService.user$
      .pipe(
        filter(value => !!value)
      )
      .subscribe((value: User) => {
        this.user = value;
      })

    this.keyboardChanged$
      .pipe(
        tap((value: string) => {
          if(value === 'left') { 
            if(this.user.keyboard_in_use <= 1) { this.user.keyboard_in_use = 5; }
            else { this.user.keyboard_in_use = +this.user.keyboard_in_use - 1; }
          }
  
          if(value === 'right') { 
            if(this.user.keyboard_in_use >= 5) { this.user.keyboard_in_use = 1; }
            else { this.user.keyboard_in_use = +this.user.keyboard_in_use + 1; }
          }
        }),
        switchMap(_ => this.apiService.saveKeyboard(this.user))
      )      
      .subscribe(_ => { 
        // nothing to do
      })
  }

  launch() {
    this.systemService.inGameMode$.next(true);
    this.router.navigate(['keylesson'])
  }

}
